import Vue from 'vue'
import axios from 'axios'
import store from 'store'
const theme = VUE_APP_THEME
console.log('theme: ' + theme)

let baseURL = '/'

switch (process.env.NODE_ENV) {
  case 'production':
    switch (theme) {
      case 'theme1' :
        baseURL = 'https://dataroom.groupe-casino.fr/'
        break
      case 'theme2':
        baseURL = 'https://www.dataroom-immo.fr/'
        break
    }
    break
  case 'recette':
    switch (theme) {
      case 'theme1' :
        baseURL = 'https://dataroom-rec.groupe-casino.fr/'
        break
      case 'theme2':
        baseURL = 'https://www-rec.dataroom-immo.fr/'
        break
    }
    break
  case 'development':
    switch (theme) {
      case 'theme1' :
        baseURL = 'http://127.0.0.1:3000/'
        break
      case 'theme2':
        baseURL = 'http://127.0.0.1:3000/'
        break
    }
    break
}

console.log('baseURL ' + baseURL + ' Theme: ' + process.env.THEME + ' Node_Env: ' + process.env.NODE_ENV + ' VueAppTheme: '+VUE_APP_THEME)
const api = axios.create({
  baseURL,
})
api.interceptors.response.use(response => response.data)

Vue.prototype.$api = api
Vue.api = api

// auth token
const token = store.get('token')
if (token) {
  api.defaults.headers.common['Authorization'] = 'Bearer ' + token
}

// api error handling
Vue.mixin({
  methods: {
    /**
     * Affiche une erreur d'API dans un toast.
     *
     * L'API repond `{ error, requestId }`, avec le code dans le statut HTTP. Le message
     * renvoye est prefere au libelle generique, notamment sur les 400 dont le detail dit
     * precisement ce qui est invalide. Les erreurs axios portent ces donnees dans
     * `response`.
     *
     * Le requestId est affiche : il permet au support de correler un incident signale par
     * l'utilisateur avec les journaux de l'API.
     *
     * @param {Error|string} err Erreur axios, ou message deja pret a afficher.
     */
    apiError (err) {
      const show = (message) => this.$toast.open({
        message,
        type: 'is-danger',
        position: 'is-bottom',
        duration: 6000,
      })

      // Chaine fournie directement par un composant : affichee telle quelle.
      if (typeof err === 'string') {
        return show(err)
      }

      const response = (err && err.response) || {}
      // `err.status` en repli : pdf.js leve une UnexpectedResponseException qui porte le
      // code directement, sans objet `response` (cf. l'apercu documentaire).
      const status = response.status || (err && err.status)

      // Le corps n'est pas toujours du JSON : une erreur de passerelle renvoie du HTML,
      // et les requetes en `arraybuffer` (apercu documentaire, CGA) un ArrayBuffer. D'ou
      // le test de type avant de lire `.error`.
      const data = (response.data && typeof response.data === 'object') ? response.data : {}

      let message = data.error

      if (!message) {
        if (status === 403) {
          message = this.$t('apierror.forbidden')
        } else if (status === 404) {
          message = this.$t('apierror.notfound')
        } else if (status >= 500) {
          message = this.$t('apierror.server')
        } else {
          message = this.$t('apierror.network')
        }
      }

      if (data.requestId) {
        message += ' — ' + this.$t('apierror.reference', { id: data.requestId })
      }

      show(message)
    },
  },
})

export default api